package amazon.lastmile.inject

import app.nestbridge.feature.invitations.api.InvitationApiClient
import app.nestbridge.feature.invitations.api.RemoteInvitationApiClient
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = RemoteInvitationApiClient::class)
public interface AppNestbridgeFeatureInvitationsApiRemoteInvitationApiClient {
  @Provides
  public fun provideRemoteInvitationApiClientInvitationApiClient(remoteInvitationApiClient: RemoteInvitationApiClient): InvitationApiClient = remoteInvitationApiClient
}
